// extracted by mini-css-extract-plugin
export default {"themeSwitcher":"ThemeSwitcher_themeSwitcher__+CeQn"};